import { el, clear } from '../../utils/dom.js';
import { Auth } from '../../api/resources.js';
import { auth } from '../../store/auth.js';
import { navigate } from '../../router/index.js';
import { err } from '../../components/toast.js';

export default async function LoginPage(outlet) {
  clear(outlet);

  const errBox = el('div', { class: 'err mb-3', style: 'display:none' });
  const submitBtn = el('button', { class: 'btn primary', type: 'submit', style: 'width:100%' }, 'Entrar');

  const form = el('form', {
    onsubmit: async (e) => {
      e.preventDefault();
      errBox.style.display = 'none';
      submitBtn.disabled = true;
      submitBtn.textContent = 'Entrando...';
      const fd = new FormData(form);
      try {
        const data = await Auth.login(fd.get('email'), fd.get('password'));
        auth.set(data);
        navigate('/');
      } catch (ex) {
        errBox.textContent = ex.message || 'Error al iniciar sesion';
        errBox.style.display = 'block';
        err(ex.message);
      } finally {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Entrar';
      }
    },
  });

  form.append(
    el('div', { class: 'field' },
      el('label', { for: 'email' }, 'Correo'),
      el('input', { id: 'email', name: 'email', type: 'email', class: 'input', autocomplete: 'username', required: true, autofocus: true }),
    ),
    el('div', { class: 'field' },
      el('label', { for: 'password' }, 'Contrasena'),
      el('input', { id: 'password', name: 'password', type: 'password', class: 'input', autocomplete: 'current-password', required: true }),
    ),
    errBox,
    submitBtn,
  );

  const card = el('div', { class: 'auth-card' },
    el('div', { class: 'brand-logo', 'aria-label': 'Abby Pixel' }, ''),
    el('div', { class: 'brand' }, 'Bienvenido de vuelta'),
    el('div', { class: 'sub' }, 'Inicia sesion para acceder al panel de inventario, prestamos y rentas.'),
    form,
  );

  outlet.appendChild(el('div', { class: 'auth-shell' }, card));
}
